import { getLocalizedString } from "@icarius-localization/strings";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";

export const COLUMN_PATHS = {
    modules: "/modulesAndMenus/modules",
    menus: "/modulesAndMenus/menus",
    exclusions: "/modulesAndMenus/exclusions",
    exclusionsUserSelection: "/modulesAndMenus/exclusions/userSelection",
}

export default () => [
    // modules
    {
        pages: [COLUMN_PATHS.modules],
        config: {
            headerName: getLocalizedString("name"),
            field: "name",
            filter: "agTextColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: [COLUMN_PATHS.modules],
        config: {
            headerName: getLocalizedString("active"),
            field: "activeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.modules],
        config: {
            headerName: getLocalizedString("description"),
            field: "description",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.modules],
        config: {
            headerName: getLocalizedString("editable"),
            field: "editableString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.modules],
        config: {
            headerName: getLocalizedString("sqlFilter"),
            field: "sqlFilter",
            filter: "agTextColumnFilter",
        }
    },
    // menus
    {
        pages: [COLUMN_PATHS.menus],
        config: {
            headerName: getLocalizedString("name"),
            field: "name",
            filter: "agTextColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: [COLUMN_PATHS.menus],
        config: {
            headerName: getLocalizedString("module"),
            field: "moduleString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.menus],
        config: {
            headerName: getLocalizedString("active"),
            field: "activeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.menus],
        config: {
            headerName: getLocalizedString("path"),
            field: "path",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.menus],
        config: {
            headerName: getLocalizedString("description"),
            field: "description",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.menus],
        config: {
            headerName: getLocalizedString("editable"),
            field: "editableString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.menus],
        config: {
            headerName: getLocalizedString("role"),
            field: "roleString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.menus],
        config: {
            headerName: getLocalizedString("type"),
            field: "typeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.menus],
        config: {
            headerName: getLocalizedString("childrenOf"),
            field: "childOfString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.menus],
        config: {
            headerName: getLocalizedString("hiddenByChildren"),
            field: "hiddenByChildrenString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.menus],
        config: {
            headerName: getLocalizedString("sqlFilter"),
            field: "sqlFilter",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.menus],
        config: {
            headerName: getLocalizedString("requiredMenu"),
            field: "requiredMenuString",
            filter: "agSetColumnFilter",
        }
    },
    // exclusions
    {
        pages: [COLUMN_PATHS.exclusions],
        config: {
            headerName: getLocalizedString("module"),
            field: "moduleString",
            filter: "agSetColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: [COLUMN_PATHS.exclusions],
        config: {
            headerName: getLocalizedString("menu"),
            field: "menuString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusions],
        config: {
            headerName: getLocalizedString("role"),
            field: "roleString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusions],
        config: {
            headerName: getLocalizedString("employees"),
            field: "codempsString",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusions],
        config: {
            headerName: getLocalizedString("sqlFilter"),
            field: "sqlFilter",
            filter: "agTextColumnFilter",
        }
    },
    // user selection
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "CODIGO DE EMPLEADO",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "APELLIDO Y NOMBRE",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "ESTADO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config:
        {
            headerName: getLocalizedString("icariusAccess"),
            field: "HABILITAR EL ACCESO A ICARIUS",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: "FECHA DE INGRESO",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("position"),
            field: "CARGO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("function"),
            field: "FUNCIÓN",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("fType"),
            field: "TIPO DE FUNCIONARIO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "LUGAR DE TRABAJO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "OBRA O FAENA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "CENTRO DE COSTO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("plantPersonnel"),
            field: "PERSONAL DE PLANTA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("management"),
            field: "GERENCIA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("department"),
            field: "DEPARTAMENTO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("jornadaType"),
            field: "TIPO DE JORNADA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("SHOW_DIVISION"),
            field: "UNIDAD DE NEGOCIO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("email"),
            field: "EMAIL",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("personalEmail"),
            field: "EMAIL PERSONAL",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [COLUMN_PATHS.exclusionsUserSelection],
        config: {
            headerName: getLocalizedString("workMode"),
            field: "MODALIDAD DE TRABAJO",
            filter: "agSetColumnFilter",
        }
    },
]